import { useRouter } from 'next/router';

import Head from 'next/head';
import Image from 'next/image';
import Link from 'next/link';

import React, { useEffect, useState } from 'react';

function Home ({ defaultMetaTagData }) {
  const metaTagData = {
    shareTitle: 'SBS 이벤트 : 가을가을한 SBS 인기프로그램 초고화질 무료',
    shareDescription: '힐링이 필요한 가을 SBS 인기프로그램 초고화질 무료로 즐기세요',
    shareImageUrl: 'https://program-image.cloud.sbs.co.kr/og/sbs_event.png',
    currentUrl: 'https://www.sbs.co.kr/promotion/hdfree',
    keywords: 'SBS VOD 무료'
  };

  const eventProgramList = [{ programTitle: '달의 연인 보보경심 려', programPosterImg: 'https://image.sbs.co.kr/event/template_autumn_event_2021/pc/img/scarletheart.png', programLink: 'https://programs.sbs.co.kr/drama/scarletheart/vods/52264' },
    { programTitle: '당신이 잠든 사이에', programPosterImg: 'https://image.sbs.co.kr/event/template_autumn_event_2021/pc/img/wyws.png', programLink: 'https://programs.sbs.co.kr/drama/wyws/vods/50566' },
    { programTitle: '여우각시별', programPosterImg: 'https://image.sbs.co.kr/event/template_autumn_event_2021/pc/img/wherestarsland.png', programLink: 'https://programs.sbs.co.kr/drama/wherestarsland/vods/56362' },
    { programTitle: '주군의 태양', programPosterImg: 'https://image.sbs.co.kr/event/template_autumn_event_2021/pc/img/juguntaeyang.png', programLink: 'https://programs.sbs.co.kr/drama/juguntaeyang/vods/52859' },
    { programTitle: '괜찮아 사랑이야', programPosterImg: 'https://image.sbs.co.kr/event/template_autumn_event_2021/pc/img/oklove.png', programLink: 'https://programs.sbs.co.kr/drama/oklove/vods/52679' },
    { programTitle: '그 겨울, 바람이 분다', programPosterImg: 'https://image.sbs.co.kr/event/template_autumn_event_2021/pc/img/baramibunda.png', programLink: 'https://programs.sbs.co.kr/drama/baramibunda/vods/52929' },
    { programTitle: '이동욱은 토크가 하고 싶어서', programPosterImg: 'https://image.sbs.co.kr/event/template_autumn_event_2021/pc/img/wooktalk.png', programLink: 'https://programs.sbs.co.kr/enter/wooktalk/vods/62875' },
    { programTitle: '힐링캠프', programPosterImg: 'https://image.sbs.co.kr/event/template_autumn_event_2021/pc/img/healingcamp.png', programLink: 'https://programs.sbs.co.kr/enter/healingcamp/vods/54428' },
    { programTitle: '패밀리가 떴다', programPosterImg: 'https://image.sbs.co.kr/event/template_autumn_event_2021/pc/img/family.png', programLink: 'https://programs.sbs.co.kr/enter/family1/vods/55951' },
    { programTitle: '리틀 포레스트', programPosterImg: 'https://image.sbs.co.kr/event/template_autumn_event_2021/pc/img/littleforest.png', programLink: 'https://programs.sbs.co.kr/enter/forestbaby/vods/60317' },
    { programTitle: '라이프 오브 사만다', programPosterImg: 'https://image.sbs.co.kr/event/template_autumn_event_2021/pc/img/samantha.png', programLink: 'https://programs.sbs.co.kr/culture/samantha/vods/62636' },
    { programTitle: '내 방 안내서', programPosterImg: 'https://image.sbs.co.kr/event/template_autumn_event_2021/pc/img/myroom.png', programLink: 'https://programs.sbs.co.kr/culture/myroom/vods/50531' }
  ];

  return (
    <>
      <Head>
        <link key='css_pc_url' rel='stylesheet' href='//image.sbs.co.kr/event/template_autumn_event_2021/pc/css/template_secret_event_pc.css' />
        <meta key='viewport' name='viewport' content='width=device-width, initial-scale=1' />
        <script key='gnb_js_url' type='text/javascript' src={process.env.NEXT_PUBLIC_GNB_JS_URL} />

        <meta name='description' content={metaTagData.shareDescription} />
        <meta name='keywords' content={metaTagData.keywords} />
        <meta name='twitter:card' content='summary' />
        <noscript>Your browser does not support JavaScript!</noscript>
        <meta property='og:type' content='website' />
        <meta property='og:locale' content='ko_KR' />
        <meta property='og:site_name' content='SBS' />
        <meta property='og:title' content={metaTagData.shareTitle || ''} />
        <meta property='og:description' content={metaTagData.shareDescription || ''} />
        <meta property='og:image' content={metaTagData.shareImageUrl || ''} />
        <meta property='og:url' content={metaTagData.currentUrl || ''} />
        <meta name='nate:site_name' content='SBS' />
        <meta name='nate:title' content={metaTagData.shareTitle || ''} />
        <meta name='nate:description' content={metaTagData.shareDescription || ''} />
        <meta name='nate:image' content={metaTagData.shareImageUrl || ''} />
        <meta name='nate:url' content={metaTagData.currentUrl || ''} />
        <title>{metaTagData.shareTitle}</title>
      </Head>

      {/* 탬플릿별 클래스 추가 */}
      <div className='template_secret_event_w autumn_2021'>
        <div className='template_secret_event_inner'>
          {/* 메인 비주얼 */}
          <div className='tse_visual_w'>
            <h2 className='tse_visual_inner'>
              <img src='https://image.sbs.co.kr/event/template_autumn_event_2021/pc/img/top_visual.png' className='tse_visual_image' alt='힐링이 필요한 10월, 가을가을한 SBS 인기 프로그램을 초고화질 무료로 즐기세요!, 2021.10.08 ~ 2021.10.31' />
            </h2>
          </div>
          {/* vod 리스트 */}
          <div className='tse_vod_list_w'>
            <ul className='tse_vod_list'>
              {eventProgramList.map((item, index) => {
                return (
                  <li key={index} className='tse_vod_list_box'>
                    <a href={item.programLink} target='_blank' className='tse_vod_list_link'>
                      <div className='tse_vod_image_w'>
                        <img src={item.programPosterImg} className='tse_vod_image' alt={item.programTitle} />
                      </div>
                      <div className='tse_vod_title'>
                        <strong className='tse_vod_text'>{item.programTitle}</strong>
                      </div>
                    </a>
                    <button type='button' className='tse_vod_btn' onClick={() => window.open(item.programLink)}>
                      <strong className='tse_vod_btn_buy'>보러가기</strong>
                    </button>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>

    </>
  );
}

export default Home;
